<template>
  <Popover
    trigger="click"
    class="AccountMenu"
    placement="bottom"
    :bound-to="{ x: 'viewport' }"
    :margin="{ right: 8 }"
    :offset="{ y: 10 }"
    popover-class="account-menu-popover popover-default"
    :trigger-attrs="{ title: $t('nav.account'), 'aria-label': $t('nav.account'), 'aria-haspopup': 'true' }"
  >
    <template #trigger>
      <span class="account-button">
        <UserAvatar
          v-if="currentUser"
          :user-id="currentUser.id"
          compact
        />
        <FAIcon
          v-else
          fixed-width
          class="fa-scale-110 fa-old-padding"
          icon="user"
        />
        <span
          v-if="waiting"
          class="badge -dot -notification"
        />
      </span>
    </template>
    <template #content="{ close }">
      <AccountMenuList
        place="desktop"
        @done="close"
      />
    </template>
  </Popover>
</template>

<script src="./account_menu.js"></script>

<style lang="scss">
.AccountMenu {
  /* the avatar in the middle of the bar's height */
  display: flex;
  align-items: center;
  height: 100%;

  .popover-trigger-button {
    display: flex;
    align-items: center;
  }

  .account-button {
    position: relative;
    display: inline-flex;
    align-items: center;

    /* no text line around the image: it would sit on its baseline */
    .Avatar {
      display: flex;
    }

    .Avatar,
    .avatar {
      width: 1.75em;
      height: 1.75em;
    }

    .badge.-dot {
      left: auto;
      top: -0.1em;
      right: -0.3em;
    }
  }
}

.account-menu-popover {
  min-width: 16rem;
  font-size: 1rem;
}
</style>
